import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'

export class UpdateCreditCardApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'dealer/updateCreditCard',
      requesterInfo,
    })
  }

  public async updateCard(req: any): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
